import {
    createMediaSegmentBlock,
} from '@vfde-brix/media-segment';

import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

export const mountMediaSegment = () => {
    const elements = document.getElementsByClassName('brix-media-segment');

    for (let i = 0, x = elements.length; i < x; i += 1) {

        const containerElement = elements[i].parentNode as HTMLElement;
        createMediaSegmentBlock(containerElement, NO_PATTERN_BUSINESS_LOGIC);

    }
}
